import React from "react";
import FeatureCard from "../../../components/featuredCard";
import HeaderSection from "../../../components/headerSection";
import ImageTextCard from "../../../components/imageTextCard";
import Footer from "../home/footer";
import PersonalPlan from "./personalPlan";
function Skilling() {
  const obj = [
    {
      title: "Communications",
      description:
        "Effective communication is essential for conveying ideas clearly, fostering collaboration, and building strong relationships in a team-oriented environment.",
    },
    {
      title: "Ethical Decision Making:",
      description:
        "Ethical decision-making assesses choices based on moral principles, aligning actions with organizational values and fostering a culture of trust and integrity.",
    },
    {
      title: "Leadership and Team Management:",
      description:
        "Ethical decision-making aligns choices with moral principles and organizational values, fostering trust and integrity in the workplace.",
    },
    {
      title: "Creativity and Innovation",
      description:
        "Creativity and innovation foster new ideas and solutions, enhancing problem-solving and keeping organizations competitive in a changing landscape.",
    },
    {
      title: "Project Management:",
      description:
        "roject management entails planning and executing projects to ensure timely and budget-compliant delivery while managing resources and stakeholder expectations.",
    },
  ];

  const card = [
    {
      title: "AI Foundational Courses",
      image: "/job1.png",
      description:
        "Build foundational skills and confidence to navigate an AI-driven world.",
    },
    {
      title: "Deepen Your AI Knowledge and Skills",
      image: '/job2.png',
      description:
        "Move beyond the basics with targeted learning to prepare for AI-driven work environments.",
    },
    {
      title: "Refine Your Expertise and Explore Advanced Applications",
      image: "/job3.png",
      description:
        "Specialize your skills and prepare for leadership roles in AI-driven projects.",
    },
  ];
  return (
    <div>
      <HeaderSection
        title="Skilling"
        description="Build In-Demand Skills to Thrive in the AI-Driven Workforce"
      />
      <ImageTextCard
        image="/skilling.png"
        position="left"
        imageClass="w-[640px] h-auto"
        label="Empower Your Future with AI Skills"
        subTitle="In an era where AI and automation are reshaping the job landscape, workers who upskill in AI will remain relevant and competitive. Our Skilling section is dedicated to empowering you with the knowledge and abilities needed to thrive in AI-resilient careers. By integrating insights from your AI Job Assessment, we provide personalized learning paths and resources to help you acquire in-demand skills efficiently and effectively. make a heading and sub heading"
      />
      <ImageTextCard
        image="/soft-skills.png"
        imageClass="w-[620px] h-auto"
        label="The Crucial Role of Soft Skills in an AI-Driven Workplace"
        obj={obj}
      />
      <FeatureCard
        label="Upcoming Courses"
        description="Enhance your career with expertly designed courses tailored for the AI-driven landscape, equipping you with critical skills and insights to stay ahead and thrive."
        cards={card}
      />
      <PersonalPlan />
      {/* <LogoSlider /> */}
      <Footer />
    </div>
  );
}

export default Skilling;
